jQuery(document).ready(function($){
    if(!$('body').hasClass('home')) {
        return;
    }
    $(function() {
        //Set the top offset of the page with the widgets
        var m = $('.top-message-wrapper');
        var p = $('.page-container');
        $(window).bind('resize.changePageOffset', function() {
            p.css({'margin-top':m.height(),'padding-top': 10});
        }).trigger('resize.changePageOffset');


        //Init the widgets
        $('.widget-wrapper').each(function() {
            var w = $(this);
            var name = w.attr('data-widget');
            var fn = 'init_'+name+'_widget(window, filters)';
            var window = w.parents('.window-wrapper');
            var filters = {};



            $.get('/widgets/'+name+'/getView', function(html) {
                w.html(html);

                var filters_form = window.find('form');
                if(filters_form.length > 0) {
                    filters = filters_form.serializeJSON();


                    window.find('[data-course-selector]').courseSelector();
                    window.find('[data-company-selector]').companySelector();


                    filters_form.submit(function(e) {
                        e.preventDefault();
                        filters = $(this).serializeJSON();
                        eval(fn);
                    });

                    filters_form.find(':input.filter').change(function() {
                        var xhr = window[0].xhr;
                        if(xhr != undefined) {
                            xhr.abort();
                        }
                        $(this).parents('form').submit();
                    });
                }

                eval(fn);

                window.fadeIn(200);
            });
        });
    });

    $(() => {
        function resizeGridItem(item){
            const grid = document.getElementsByClassName("widgets-container")[0];
            const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
            const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
            const rowSpan = Math.ceil((item.querySelector('.window-wrapper').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

            item.style.gridRowEnd = "span "+rowSpan;
        }

        function resizeAllGridItems(){
            const allItems = document.getElementsByClassName("widget-container");
            for(let x=0;x<allItems.length;x++){
                resizeGridItem(allItems[x]);
            }
        }

        // function resizeInstance(instance){
        //     const item = instance.elements[0];
        //     resizeGridItem(item);
        // }

        window.onload = resizeAllGridItems();
        window.addEventListener("resize", resizeAllGridItems);

        setInterval(() => {
            const container = $('.widgets-container');
            const prevHeight = container[0].prevHeight;
            let h = 0;

            $('.widgets-container .window-wrapper').each(function() {
                h = h + $(this).height();
            });

            if (prevHeight !== h) {
                resizeAllGridItems();
                container[0].prevHeight = h;
            }

        }, 100);

        $('#toggle-widgets').change(function() {
            $('.widgets-container').toggleClass('show-widgets', !$(this).is(':checked'))
        });
        setTimeout(() => {
            $('#toggle-widgets').trigger('change');
        }, 1000);
    })
});

function reload_dashboard_widgets($) {
    if(!$('body').hasClass('home')) {
        return false;
    }
    $('.widget-wrapper form').submit();
    return true;
}
